import React from "react";
import { Container, ImgHolder } from "./styles";
import isMobile from "~/hooks/isMobile";

// Importar as imagens diretamente
import imgDesk from "~/assets/img/bebe-palco.png";
import imgMobile from "~/assets/img/bebe-palco.png";

const ImgGirl = () => {
    const mobile = isMobile();

    return (
        <Container>
            <ImgHolder>
                <img 
                    src={mobile ? imgMobile : imgDesk} 
                    alt="Bebê Johnson's" 
                    loading="lazy"
                />
            </ImgHolder>
        </Container>
    );
};

export default ImgGirl;
